<div class="container">
  <h1>Créer mon compte</h1>
  <p>Votre compte vétérinaire n'est pas lié à une clinique MyPacs.</p>
  <p>Merci de remplir les champs ci-dessous afin de compléter la création de votre compte.</p>

  <mat-stepper orientation="vertical" [linear]="true">
    <mat-step [stepControl]="userFormGroup" [label]="'register.stepper.user_title' | translate">
      <div class="screen">
        <app-scc-user [userFormGroup]="userFormGroup" [usePassword]="usePassword"
          [orderNumber]="orderNumber"
          [firstname]="firstname"
          [lastname]="lastname"
          [mail]="mail"></app-scc-user>
      </div>
      <div class="flex-row">
        <button color="accent" mat-raised-button matStepperNext>
          {{'register.stepper.forward' | translate}} <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
    </mat-step>

    <mat-step [stepControl]="clinicFormGroup" [label]="'register.stepper.check_dpe' | translate">
      <div class="screen">
        <app-scc-clinic [clinicFormGroup]="clinicFormGroup" (clinicSelected)="setClinic($event)"></app-scc-clinic>
      </div>
      <div class="flex-row">
        <button color="accent" mat-raised-button matStepperPrevious>
          <mat-icon>arrow_back</mat-icon> {{'register.stepper.back' | translate}}
        </button>
        <button color="accent" mat-raised-button matStepperNext>
          {{'register.stepper.forward' | translate}} <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
    </mat-step>

    <mat-step [label]="'register.stepper.done_title' | translate">
      <div class="sumary">
        <mat-card>
          <mat-card-header>
            <mat-card-title>
              Mon compte
            </mat-card-title>
          </mat-card-header>

          <mat-card-content>
            <div>{{userFormGroup.get('firstName')?.value}} {{userFormGroup.get('lastName')?.value}}</div>
            <div>Numéro d'ordre : {{userFormGroup.get('orderNum')?.value}}</div>
            <div>{{userFormGroup.get('email')?.value}}</div>
          </mat-card-content>
        </mat-card>

        <mat-card>
          <mat-card-header>
            <mat-card-title>
              Ma clinique
            </mat-card-title>
          </mat-card-header>

          <mat-card-content>
            <ng-container *ngIf="clinic else createClinicContent">
              <div>{{ clinic.name }}</div>
              <div *ngIf="clinic.hasPaymentMethod">
                <strong>L'administrateur de la clinique devra confirmer votre inscription</strong>
              </div>
            </ng-container>
          </mat-card-content>

          <ng-template #createClinicContent>
            <div>{{ clinicFormGroup.get('name')?.value}}</div>
            <div>{{ clinicFormGroup.get('address1')?.value}}</div>
            <div>{{ clinicFormGroup.get('address2')?.value}}</div>
            <div>
              <span>{{ clinicFormGroup.get('zipCode')?.value}}</span>&nbsp;
              <span>{{clinicFormGroup.get('city')?.value}}</span>
            </div>
            <div>{{ clinicFormGroup.get('email')?.value}}</div>
            <div>{{ clinicFormGroup.get('phone')?.value}}</div>
          </ng-template>
        </mat-card>

      </div>
      <div class="flex-row">
        <button color="accent" mat-raised-button matStepperPrevious [disabled]="isSending">
          <mat-icon>arrow_back</mat-icon> {{'register.stepper.back' | translate}}
        </button>
        <button color="accent" mat-raised-button (click)="save()">
          {{'register.stepper.forward' | translate}} <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
      <p class="error-message" *ngIf="errorMessage">{{ errorMessage }}</p>
    </mat-step>

    <mat-step [label]="'register.stepper.payment_title' | translate" *ngIf="!clinic?.hasPaymentMethod">
      <ng-template matStepContent>
        <div class="screen">
          <app-scc-payment></app-scc-payment>
        </div>
      </ng-template>
    </mat-step>
  </mat-stepper>
</div>
